var getFullName = function getFullName(_ref) {
  var firstName = _ref.firstName,
    secondName = _ref.secondName,
    lastName = _ref.lastName;
  return [lastName, firstName, secondName].filter(Boolean).join(" ");
};
export default getFullName;